// @ts-check
import {BugReporting} from "tensorbuzz-api"
import Devise from "@kaspernj/api-maker/build/devise"
import env from "shared/env"

const tensorbuzzJsAuthToken = globalThis.TENSORBUZZ_JS_AUTH_TOKEN || env["TENSORBUZZ_JS_AUTH_TOKEN"]

if (tensorbuzzJsAuthToken) {
  globalThis.tensorBuzzErrors = new BugReporting({
    authToken: tensorbuzzJsAuthToken,
    runtimeEnvironment: "browser"
  })
  globalThis.tensorbuzzErrors = globalThis.tensorBuzzErrors
  globalThis.tensorBuzzErrors.collectEnvironment(() => {
    return {
      currentUserId: Devise.currentUser()?.id(),
      currentUserEmail: Devise.currentUser()?.email()
    }
  })
  globalThis.tensorBuzzErrors.connect()
}
